import MoneyItem from "./MoneyItem.js";

export default class Dollar extends MoneyItem
{
    constructor(scene, x, y, dollarData)
    {
        super(scene, x, y, dollarData);

        this.setInteractive(new Phaser.Geom.Rectangle(6, dollarData.offsetY - 77, 365, 153), Phaser.Geom.Rectangle.Contains);
        this.scene.input.setDraggable(this);

        this.setBody({ type: 'rectangle', width: 365, height: 153 });
        this.displayOriginY = dollarData.offsetY;

        this.setCollisionCategory([]);
        this.setFrictionAir(.08);
    }

    draggingStarted()
    {
        this.scene.addTween(this, 300, {scaleX: this.scaleX * 1.1, scaleY: this.scaleY * 1.1, easeParams: [.8, .5]}, "Elastic");
        this.scene.addTween(this.shadow, 300, {xOffset: 10, yOffset: 10}, "Elastic");
        this.setCollisionGroup(this.scene.noCollide_group);
    }

    draggingStopped()
    {
        this.setCollisionGroup([]);
        this.scene.addTween(this.shadow, 300, {xOffset: 5, yOffset: 5}, "Elastic");
    }
}